import { CSSProperties, ReactElement, ReactNode, SyntheticEvent } from 'react';
import {
  Chip as MUIChip,
  ChipProps as MUIChipProps,
  SxProps,
  Theme,
} from '@mui/material';
import * as R from 'ramda';

import { CancelIcon } from '@atom/mui/icons';

type AtomMUIProps = {
  avatar?: ReactElement<any>;
  classes?: any;
  label?: ReactNode;
  style?: CSSProperties;
  sx?: SxProps<Theme>;
  onDelete?: () => void;
  color?:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning';
  onClick?: (event: SyntheticEvent<any>) => void;
  'data-cy'?: string;
};

export type ChipProps = AtomMUIProps;

const styles = {
  maxWidth: '100%',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
};

export const Chip = (props: ChipProps) => {
  const labelSx: SxProps<Theme> = {
    '.MuiChip-label': {
      paddingLeft: !!props.avatar ? 0 : '0.5rem',
    },
  };

  const MUIProps: MUIChipProps = R.omit(['style', 'sx'], props);

  const dataCy = props['data-cy'];
  const deleteIcon =
    props.onDelete && dataCy ? (
      <CancelIcon data-cy={`${dataCy}-DeleteButton`} />
    ) : undefined;

  const sx: SxProps<Theme> = [
    labelSx,
    ...(Array.isArray(props.sx) ? props.sx : [props.sx ?? {}]),
  ];

  return (
    <MUIChip
      sx={sx}
      style={{ ...styles, ...props.style }}
      deleteIcon={deleteIcon}
      {...MUIProps}
    />
  );
};
